import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const TravelTourismManagementCareerSkills = () => {
  return (
    <CareerSkillsSection
      title="TRAVEL & TOURISM MANAGEMENT SKILLS? CHECK."
      paragraphs={[
        `In Travel & Tourism Management at JRIIT, you'll get an education built on core programs that are vital for success in today's hospitality industry — expertise in tourism operations, customer service, destination management, and hospitality leadership. These are the skills that employers say make JRIIT Travel & Tourism Management graduates stand out. Our Travel & Tourism Management program offers both a 1-year Certificate for foundational skills and a 2-year Diploma for advanced specialization in tourism management.`,

        `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you'll receive detailed feedback on your hospitality strengths and where you can improve, giving you a more complete picture of your growth.`,

        `Discover our Travel & Tourism Management programs below and unlock the skills to shape your future.`,
      ]}
    />
  );
};

export default TravelTourismManagementCareerSkills;
